import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

class Toast extends Component {
    constructor(props) {
        super(props);

        this.timeout = this.props.timeout ? this.props.timeout : 1000;
        this.state = {
            massage: "",
            display: false,
        }
    }

    set(mode, message) {
        this.setState({
            mode: mode,
            message: message,
            display: true,
        });

        setTimeout(() => {
            this.setState({
                display: false,
            });
        }, this.timeout);
    }
    render() {
        return (
            <Body name="toast" 
                Top={this.props.top}
                Bottom={this.props.bottom}
                Left={this.props.left}
                Right={this.props.right}
                data-mode={this.state.mode}
                Display={this.state.display}>
                <div style={{padding: "10px 0px 10px 0px"}}>
                    {this.state.message}
                </div>
            </Body>
        )
    }
}

export { Toast };

Toast.propTypes = {
    timeout: PropTypes.number.isRequired,
    top: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    right: PropTypes.string,
};

const Body = styled.div`
    position: fixed;
    ${props => props.Top ? css`
        top: ${props => props.Top};
    `:""};
    ${props => props.Bottom ? css`
        bottom: ${props => props.Bottom};
    `:""};
    ${props => props.Left ? css`
        left: ${props => props.Left};
    `:""};
    ${props => props.Right ? css`
        right: ${props => props.Right};
    `:""};
    opacity: ${props => props.Display ? "1" : "0"};

    &[data-mode = '0'] {
        background-color: #FFEEEE;
        color: #f00;
        border: 1px solid #f00;
    }
    &[data-mode = '1'] {
        background-color: #EEFFEE;
        color: #080;
        border: 1px solid #080;
    }
    &[data-mode = '2'] {
        background-color: #EEEEFF;
        color: #00f;
        border: 1px solid #00f;
    }
    display: inline-block;
    transition-duration: 0.2s;
    z-index: 10;
`;